{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/OHAT",
	"name": "OHAT",
	"language": "nl-BE",
	"title": "OHAT schaal",
	"status": "active",
	"publisher": "Corilus NV",
	"description": "De score 0 betekent ‘in goede gezondheid’, de score 2 ‘in slechte toestand. In geval van een 1 of 2 score voor eender welk item, moet men de patiënt onmiddellijk naar een tandarts doorverwijzen. Als men de scores optelt, bekomt men een waarde tussen 0 en 16. Hoe hoger de score, hoe slechter de gezondheidstoestand van de mond.",
	"purpose": "Evalueert de mondgezondheid",
	"item": [
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60200",
			"text": "Lippen",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60201",
						"display": "Glad, roze, vochtig"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60202",
						"display": "Droog, gebarsten of rood in mondhoeken"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60203",
						"display": "Zwelling of knobbel, witte/rode/verzweerde vlek; bloeding/verzworen in de hoeken"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60300",
			"text": "Tong",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60301",
						"display": "Normaal, vochtige ruwheid, roze"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60302",
						"display": "Vlekkerig, gebarsten, rood, beslagen"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60303",
						"display": "Rode en/of witte vlek, verzworen, gezwollen"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60400",
			"text": "Tandvlees en weefsels",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60401",
						"display": "Roze, vochtig, glad, geen bloeding"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60402",
						"display": "Droog, glanzend, ruw, rood, gezwollen, een zweer/pijnlijke plek onder kunstgebit"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60403",
						"display": "Gezwollen, bloeding, zweren, witte/rode vlekken, overal rood onder kunstgebit"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "60500",
			"text": "Speeksel",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "60501",
						"display": "Vochtige weefsels, waterige en normale speekseltoevoer"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "60502",
						"display": "Droge, kleverige weefsels, weinig speeksel, bewoner vindt dat hij/zij droge mond heeft"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "60503",
						"display": "Gebarsten en rode weefsels, erg weinig/geen speeksel, dik speeksel, bewoner vindt dat hij/zij droge mond heeft"
					}
				}
			]
		},
		{
			"type": "group",
			"linkId": "60599",
			"text": "Eigen tanden",
			"item": [
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"linkId": "60600",
					"text": "Heeft de bewoner eigen tanden?",
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "60601",
								"display": "Ja"
							}
						},
						{
							"valueCoding": {
								"code": "60602",
								"display": "Nee"
							}
						}
					]
				},
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"linkId": "60700",
					"text": "Eigen tanden",
					"required": true,
					"enableWhen": [
						{
							"question": "60600",
							"operator": "=",
							"answerCoding": {
								"code": "60601"
							}
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "60701",
								"display": "Geen bedorven of gebroken tanden/wortels"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "60702",
								"display": "1-3 bedorven of gebroken tanden/wortels of erg afgesleten tanden"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "60703",
								"display": "Meer dan 4 bedorven of gebroken tanden/wortels of erg afgesleten tanden of minder dan 4 tanden"
							}
						}
					]
				}
			]
		},
		{
			"type": "group",
			"linkId": "60799",
			"text": "Kunstgebit",
			"item": [
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"linkId": "60800",
					"text": "Heeft de bewoner een (gedeeltelijk) kunstgebit?",
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "60801",
								"display": "Ja"
							}
						},
						{
							"valueCoding": {
								"code": "60802",
								"display": "Nee"
							}
						}
					]
				},
				{
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"linkId": "60900",
					"text": "Kunstgebit",
					"required": true,
					"enableWhen": [
						{
							"question": "60800",
							"operator": "=",
							"answerCoding": {
								"code": "60801"
							}
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "60901",
								"display": "Geen gebroken zones of tanden, bewoner draagt gebit gewoonlijk en gebit is gemerkt met naam"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "60902",
								"display": "1 gebroken zone/tand of bewoner draagt gebit slechts 1-2 uren per dag of gebit is niet gemerkt of verloren"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "60903",
								"display": "Meer dan 1 gebroken zone/tand, bewoner heeft gebit verloren of draagt het niet, gebit zit los en heeft kleefmiddel nodig of gebit is niet gemerkt"
							}
						}
					]
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "61000",
			"text": "Mondhygiëne",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "61001",
						"display": "Schoon, geen voedselresten/tandsteen in de mond of op kunsttanden"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "61002",
						"display": "Voedselresten/tandsteen/plak op 1-2 plaatsen in de mond of op kleine zone van kunstgebit of halitose (slechte adem)"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "61003",
						"display": "Voedselresten/tandsteen/plak bijna overal in de mond of op kunstgebit of ernstige halitose (slechte adem)"
					}
				}
			]
		},
		{
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "vertical"
				}
			],
			"linkId": "61100",
			"text": "Tandpijn",
			"required": true,
			"answerOption": [
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					],
					"valueCoding": {
						"code": "61101",
						"display": "Geen verbale of fysieke tekenen noch gedrag dat op tandpijn wijst"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					],
					"valueCoding": {
						"code": "61102",
						"display": "Verbale tekenen of gedrag dat op tandpijn wijst, zoals aan gezicht trekken, op lippen bijten, niet eten, agressief gedrag"
					}
				},
				{
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					],
					"valueCoding": {
						"code": "61103",
						"display": "Fysieke tekenen van pijn (zwelling van kaak of tandvlees, gebroken tanden, zweren) en verbale tekenen of gedrag (aan gezicht trekken, niet eten, agressief gedrag)"
					}
				}
			]
		}
	]
}
